<div class="rounded-sm bg-grey-100 p-xs text-grey-700">
  <fa-icon [icon]="infoIcon" class="mr-xs"></fa-icon>
  <span>
    @if (hint()) {
      <span>{{ hint() }}</span
      ><br /><br />
    }
    <span [class.mt-xs]="hint()">{{ infoText() }}</span>
  </span>
</div>
